import { AbortableAPI, API } from 'utils';
import { GW_SERVICES_PREFIXES } from '../../constants';

import { ReserveFileRequestDTO, ReserveFileResponseDTO } from './dto';

const { FILES, FILES_GATEWAY, REQUEST } = GW_SERVICES_PREFIXES;

/** Общий эндпоинт для получения файла из базы */
export const GetCommonFile = (fileId: string) =>
  API.gatewayUnparsedGet('/models/file/', fileId);

/** Общий эндпоинт для добавления файла в базу.
 * formData должна иметь 2 ключа: file, importance.
 * importance по умолчанию 'low'. */
export const SaveFileToFilesMS = (id: string, data: FormData) =>
  API.putFilesGtwy(`${FILES}/files/`, id, data);

/** Эндпоинт для получения файла с микросервиса файлов. */

/** Получение shared_id для скачивания файла с микросервиса файлов. */
export const GetReqFileSharedIds = (params: {
  file_ids: string[] | string;
  filenames: string[] | string;
}): Promise<Record<string, string>> =>
  API.get(`/${REQUEST}/files/temporary/`, undefined, params);

export const GetFileFromFilesMS = (id: string) =>
  API.gatewayUnparsedGet(`${FILES}/files/`, id);

export const GetFileInfo = (fileId: string) =>
  API.get(`${FILES}/files/${fileId}/info/`);

export const ReserveFile = (
  body: ReserveFileRequestDTO
): Promise<ReserveFileResponseDTO> =>
  AbortableAPI.put(`/${FILES_GATEWAY}/v1/shared/files/new/`, {
    body,
  });
